import React from "react"
import { useNavigate } from "react-router-dom"
import { UserIcon, ArrowLongRightIcon, PlayIcon } from "@heroicons/react/24/solid"

function DevLanding() {
    const navigate = useNavigate()

    return (
        <div className="landing-page">
            {/* ======= HEADER ======= */}
            <header className="landing-header">
                <div className="landing-logo-diamond">
                    <div className="diamond-inner-1">
                        <div className="diamond-inner-2">
                            <div className="diamond-content">
                                <img src="/images/logo.jpg" alt="Tenancy Skills Institute" />
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    className="landing-login-btn"
                    onClick={() => navigate("/login")}
                >
                    <UserIcon />
                    Login
                </button>
            </header>

            {/* ======= HERO SECTION ======= */}
            <section className="landing-hero">
                <div className="landing-hero-text">
                    <h1>
                        Welcome to <span>PM Assist</span>
                    </h1>
                    <p className="hero-intro">
                        PM Assist is a secure online portal that enables property managers
                        to connect renters experiencing challenges in their tenancies with
                        support from a local community organisation.
                    </p>
                    <p>
                        With just a few clicks, property managers can initiate a referral to
                        connect renters with experienced support services. To ensure renters
                        remain in charge, the referral activates only after the renter
                        provides consent.
                    </p>
                    <p>
                        For community organisations, this means receiving referrals{" "}
                        <em>early</em>, so the targeted support they offer can optimise the
                        options available for the household, with a view to sustaining their
                        tenancy.
                    </p>

                    <div className="landing-finalist-badge">
                        <img src="/images/reb-gold-badge.png" alt="2026 REB Innovation Awards Finalist" />
                        <p>
                            <b>PM Assist is proudly the REB Innovation Awards 2026 Innovator of the Year - Property Management Platform.</b>
                        </p>
                    </div>
                    <div className="landing-finalist-badge">
                        <img src="/images/reiq-winner.png" alt="2026 REIQ Innovation Awards Finalist" />
                        <p>
                            <b>PM Assist is proudly a finalist for the REIQ 2026 Awards for Excellence - Industry Innovation Award.</b>
                        </p>
                    </div>
                    <div className="landing-finalist-badge landing-finalist-badge--square">
                        <img src="/images/qcoss-finalist.png" alt="2026 QCOSS Awards Finalist" />
                        <p>
                            <b>PM Assist is proudly a finalist in the Prevention Excellence category for the QCOSS 2026 Queensland Community Impact Awards.</b>
                        </p>
                    </div>
                </div>

                <div className="landing-hero-illustration">
                    <img
                        src="/images/hero-illustration.jpg"
                        alt="Hand holding phone with PM Assist app"
                        className="hero-illustration-img"
                    />
                </div>
            </section>

            {/* ======= CTA BAR ======= */}
            <section className="landing-cta-bar">
                <div className="landing-cta-content">
                    <h2>Over 700+ households referred so far!</h2>
                    <p>
                        With hundreds of households already benefiting from successful referrals, PM Assist is the easy, efficient way for property managers to connect
                        renters with support when
                        they need it most.
                    </p>

                    <div className="landing-scroll-indicator">
                        <div className="scroll-mouse">
                            <div className="mouse-body"></div>
                            <div className="mouse-arrow">▼</div>
                        </div>
                        <div>
                            <h3>Sound interesting?</h3>
                            <p>
                                If you are a property manager or community organisation
                                interested in activating the PM Assist referral pathway, email
                                our friendly team today
                            </p>
                            <a
                                className="landing-email-btn"
                                href="mailto:info@tenancyskills.com.au"
                            >
                                Email Us
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* ======= VIDEO SECTION ======= */}
            <section className="landing-video-section">
                <div className="landing-video-content">
                    <h2>Keen to learn more?</h2>
                    <p>
                        Watch this video to learn how PM Assist works, including insights
                        from property managers who've activated the PM Assist referral
                        pathway.
                    </p>
                </div>

                <div className="landing-video-player">
                    <iframe
                        src="https://www.youtube.com/embed/lfmekQV_AMQ"
                        title="PM Assist Online Referral Portal"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>

            {/* ======= FOOTER ======= */}
            <footer className="landing-footer">
                <p>
                    © 2026 PM Assist by Tenancy Skills Institute, a valued brand of
                    inCommunity Inc. All rights reserved.
                </p>
                <div className="landing-footer-links">
                    <a href="/privacy-policy">Privacy Policy</a>
                    <a href="/terms-and-conditions">Terms and Conditions</a>
                </div>
            </footer>
        </div>
    )
}

export default DevLanding
